(() => {
  const initialise = () => {
    document.querySelectorAll('[data-nov-night]').forEach(root => {
      if (root.dataset.ready === 'true') return;
      const track = root.querySelector('[data-nov-night-track]');
      const slides = Array.from(track.children);
      const choices = Array.from(root.querySelectorAll('[data-nov-night-choice]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      let pending = false;
      const select = index => {
        current = index;
        choices.forEach((choice, i) => {
          choice.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
        slides.forEach((slide, i) => { slide.inert = i !== index; });
      };
      const move = (index, smooth) => {
        select(index);
        track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant'});
      };
      choices.forEach((choice, index) => {
        choice.addEventListener('click', event => {
          event.preventDefault();
          move(index, true);
        });
      });
      track.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          const first = slides[0].offsetLeft;
          let nearest = 0;
          slides.forEach((slide, i) => {
            if (Math.abs(slide.offsetLeft - first - track.scrollLeft) < Math.abs(slides[nearest].offsetLeft - first - track.scrollLeft)) nearest = i;
          });
          select(nearest);
          pending = false;
        });
      }, {passive: true});
      new ResizeObserver(() => move(current, false)).observe(track);
      const initial = slides.findIndex(slide => '#' + slide.id === window.location.hash);
      move(initial >= 0 ? initial : 0, false);
      root.dataset.ready = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
